import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { inputsCustomizations } from './customizations/inputs';
import { dataDisplayCustomizations } from './customizations/dataDisplay';
import { feedbackCustomizations } from './customizations/feedback';
import { navigationCustomizations } from './customizations/navigation';
import { surfacesCustomizations } from './customizations/surfaces';
import { colorSchemes, shadows, shape, typography } from './themePrimitives';

interface AppThemeProps {
  children: React.ReactNode;
  disableCustomTheme?: boolean;
}

export default function AppTheme({ children, disableCustomTheme }: AppThemeProps) {
  if (disableCustomTheme) {
    return <>{children}</>;
  }

  const components = {
    ...inputsCustomizations,
    ...dataDisplayCustomizations,
    ...feedbackCustomizations,
    ...navigationCustomizations,
    ...surfacesCustomizations,
  };

  const theme = createTheme({
    typography,
    shape,
    shadows,
    components,
    colorSchemes: {
      light: {
        ...colorSchemes.light,
      },
      dark: {
        ...colorSchemes.dark,
      },
    },
  });

  return (
    <ThemeProvider
      theme={theme}
      defaultMode="light"
      // Optional: uncomment to persist user's choice
      // modeStorageKey="mui-mode"
      // colorSchemeStorageKey="mui-color-scheme"
    >
      {children}
    </ThemeProvider>
  );
}
